import ForgotPassword from './forgotPassword';
export default ForgotPassword;
